import { Paper } from "@material-ui/core";
import React, { useRef } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { baseUrl, config } from "../../../services/config";
import { DatePicker, Divider } from "antd";
import { Spinner, Table } from "react-bootstrap";
import { useAlert } from "react-alert";
import ReactToPrint from "react-to-print";
import { upperCase } from "lodash";
import { useSelector } from "react-redux";
const { RangePicker } = DatePicker;
const IncomeExpenditure = () => {
  const [selected, setSelected] = useState("all");
  let authtoken = localStorage.getItem("userToken");
  const getBranchUrl = localStorage.getItem("branchUrl");
  const [yearId, setYearId] = useState("");
  const [sessionData, setSessionData] = useState([]);
  const user = useSelector((state) => state.user.user);
  const [campusData, setCampusData] = useState(user.campuses || []);
  const [campusId, setCampusId] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setendDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [revenue, setRevenue] = useState([]);
  const [expen, setExpen] = useState([]);
  const [revSum, setRevSum] = useState(0);
  const [deSum, setDeSum] = useState(0);
  const [profit, setProfit] = useState(0);
  const [loss, setLoss] = useState(0);
  //for print
  const [printloading, setprintloading] = React.useState(false);
  const [text, setText] = React.useState("old boring text");
  const componentRef = useRef(null);
  const onBeforeGetContentResolve = React.useRef(null);
  const alert = useAlert();
  const onRadioButtonClick = (e) => {
    setSelected(e.target.value);
  };

  const [unitName, setUnitName] = useState("");
  const [icon, setIcon] = useState([]);
  const pageStyle = `
  @page {
    size: A4 !important;
}
`;
  useEffect(() => {
    getSettingData();
    sessions();
  }, []);

  const getSettingData = async () => {
    await fetch(`${baseUrl}/get-settings`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
        branchUrl: getBranchUrl,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data.payload);
        setUnitName(upperCase(data.payload.settings.unit_name));
        setIcon(data.payload.settings.logo_file);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const sessions = () => {
    fetch(`${baseUrl}/session`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
        branchUrl: getBranchUrl,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setSessionData(data.payload);
        data.payload.forEach((session, index) => {
          if (session.active_financial_year == "1") {
            setYearId(session.id);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const datePicker = (value, dateString) => {
    console.log("Formatted Selected Time: ", dateString);
    setStartDate(dateString[0]);
    setendDate(dateString[1]);
  };
  const handleGetData = () => {
    if (yearId == "") {
      alert.error("Please select the year");
      return;
    }

    setLoading(true);
    const data = {
      year_id: yearId,
      campus_id: campusId,
      start_date: startDate,
      end_date: endDate,
    };
    fetch(`${baseUrl}/income_expenditure_statement`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
        branchUrl: getBranchUrl,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (data.payload) {
          const expendata = data.payload.filter((item) => {
            if (item.account_group_code == 51 || item.account_group_code > 51) {
              return item;
            }
          });
          const revdata = data.payload.filter((item) => {
            if (item.account_group_code < 51) {
              return item;
            }
          });
          setExpen(expendata);
          setRevenue(revdata);
          let sum = 0;
          revdata.forEach((element) => {
            element.account_chart.map((suitem) => {
              suitem.sub_account.map((last) => {
                sum += parseInt(last.credit - last.debit);
              });
            });
          });
          let sum2 = 0;
          expendata.forEach((element) => {
            element.account_chart.map((suitem) => {
              suitem.sub_account.map((last) => {
                sum2 += parseInt(last.debit - last.credit);
              });
            });
          });
          let here = sum - sum2;
          let myResult = here.toString();
          if (myResult[0] == "-") {
            let los = myResult.replace("-", "");
            setLoss(los);
          } else {
            setProfit(myResult);
          }
          setRevSum(sum);
          setDeSum(sum2);
        }
        console.log("this is data", data);
      })
      .catch((err) => {
        setLoading(false);
        console.log("err is re", err);
      });
  };

  //for print
  const handleBeforePrint = React.useCallback(() => {
    console.log("`onBeforePrint` called");
  }, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    console.log("`onBeforeGetContent` called");
    setprintloading(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setprintloading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setprintloading, setText]);

  const handleAfterPrint = React.useCallback(() => {
    console.log("`onAfterPrint` called");
  }, []);

  return (
    <>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div className="row">
          <div className="col-md-6 text-center">
            <input
              checked={selected == "all"}
              onChange={(e) => onRadioButtonClick(e)}
              defaultChecked
              type="radio"
              id="all"
              value="all"
            />
            <label for="all">Over All</label>
          </div>

          <div className="col-md-6 text-center">
            <input
              checked={selected == "campus"}
              onChange={(e) => onRadioButtonClick(e)}
              type="radio"
              id="campus"
              value="campus"
            />
            <label for="campus">Campus Wise</label>
          </div>
        </div>
        <div className="row ">
          <div className="col-md-3">
            <label>
              <b>Select Session</b>
            </label>
            <div className="d-flex flex-column ">
              <select
                style={{ height: 40 }}
                className="form-select"
                name="year_id"
                value={yearId}
                aria-label="Default select example"
                onChange={(e) => setYearId(e.target.value)}
              >
                <option value="">Select Session</option>
                {sessionData &&
                  sessionData.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.year}
                    </option>
                  ))}
              </select>
            </div>
          </div>
          {selected == "campus" ? (
            <div className="col-md-3">
              <label>
                <b>Select Campus</b>
              </label>
              <div className="d-flex flex-column">
                <select
                  style={{ height: 40 }}
                  className="form-select"
                  name="year_id"
                  aria-label="Default select example"
                  onChange={(e) => setCampusId(e.target.value)}
                >
                  <option value="">Select Campus</option>
                  {campusData &&
                    campusData.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                </select>
              </div>
            </div>
          ) : null}

          <div className="col-md-3">
            <label>
              <b>Select Date</b>
            </label>
            <RangePicker style={{ height: 40 }} onChange={datePicker} />
          </div>
        </div>

        <div className="row mt-5">
          <button
            className="btn btn-primary w-100px ml-4"
            onClick={handleGetData}
          >
            Show
          </button>
          {revenue?.length || expen?.length > 0 ? (
            <ReactToPrint
              pageStyle={pageStyle}
              documentTitle={`Income and Expenditure`}
              onAfterPrint={handleAfterPrint}
              onBeforeGetContent={handleOnBeforeGetContent}
              onBeforePrint={handleBeforePrint}
              removeAfterPrint={true}
              trigger={() => (
                <button
                  disabled={printloading ? true : false}
                  className="btn btn-primary w-100px mx-4"
                >
                  {printloading ? <span>Printing..</span> : "Print"}
                </button>
              )}
              content={() => componentRef.current}
            />
          ) : null}
        </div>

        <div className="mt-5">
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Spinner class="text-center" variant="info" animation="border" />
            </div>
          ) : (
            <div id="tableboot">
              <div className="d-flex">
                <div className="">
                  <img
                    style={{ height: 100, width: 110, paddingLeft: "20px" }}
                    src={icon}
                    alt="logo"
                  />
                </div>
                <div className="mx-5" style={{ paddingTop: "10px" }}>
                  <h1>{unitName}</h1>
                  <h3>
                    Income & Expenditure Statement for the Period of {startDate}{" "}
                    to {endDate}
                  </h3>
                </div>
              </div>
              <Table responsive>
                <thead>
                  <tr id="tbl">
                    <th className="text-start">A/C Code</th>
                    <th className="text-start">Account Name</th>
                    <th className="text-center">Amount</th>
                  </tr>
                </thead>

                <tbody>
                  <tr id="tbl">
                    <th
                      className="text-center text-color-primary"
                      style={{ fontSize: "1.3rem" }}
                    >
                      Total Revenue
                    </th>
                    <th></th>
                    <th
                      className="text-center text-color-primary"
                      style={{ fontSize: "1.3rem" }}
                    >
                      {Intl.NumberFormat("en-Us").format(revSum)}
                    </th>
                  </tr>
                  {revenue &&
                    revenue.map((item) =>
                      item.account_chart.length > 0 ? (
                        <>
                          <tr id="tbl">
                            <td
                              style={{ color: "#fd12b3", fontWeight: "bold" }}
                              className="text-start"
                            >
                              {item.account_group_code}
                            </td>
                            <td
                              style={{ color: "#fd12b3", fontWeight: "bold" }}
                              className="text-start"
                            >
                              {item.account_group}
                            </td>
                            <td
                              style={{ color: "#fd12b3", fontWeight: "bold" }}
                              className="text-start"
                            >
                              {/* {item.account_group} */}
                            </td>
                          </tr>
                          {item.account_chart.map((subitem) =>
                            subitem.sub_account.length > 0 ? (
                              <>
                                <tr id="tbl">
                                  <td
                                    style={{
                                      color: "black",
                                      paddingLeft: "30px",
                                      fontWeight: "bold",
                                    }}
                                    className="text-start"
                                  >
                                    {subitem.account_chart_code}
                                  </td>
                                  <td
                                    style={{
                                      color: "black",
                                      paddingLeft: "30px",
                                      fontWeight: "bold",
                                    }}
                                    className="text-start"
                                  >
                                    {subitem.account_chart}
                                  </td>

                                  <td
                                    style={{ color: "black" }}
                                    className="text-center"
                                  >
                                    {/* {subitem.credit} */}
                                  </td>
                                </tr>
                                {subitem.sub_account.length > 0
                                  ? subitem.sub_account.map((last) => (
                                      <>
                                        <tr id="tbl">
                                          <td
                                            style={{
                                              color: "black",
                                              paddingLeft: "60px",
                                            }}
                                            className="text-start"
                                          >
                                            {last.sub_account_code}
                                          </td>
                                          <td
                                            style={{
                                              color: "black",
                                              paddingLeft: "60px",
                                            }}
                                            className="text-start"
                                          >
                                            {last.sub_account}
                                          </td>

                                          <td
                                            style={{ color: "black" }}
                                            className="text-center"
                                          >
                                            {Intl.NumberFormat("en-Us").format(
                                              last.credit - last.debit
                                            )}
                                          </td>
                                        </tr>
                                      </>
                                    ))
                                  : null}
                                <tr id="tbl">
                                  <td
                                    style={{
                                      color: "black",
                                      paddingLeft: "30px",
                                    }}
                                    className="text-start"
                                  ></td>
                                  <td
                                    style={{
                                      color: "black",
                                      paddingLeft: "200px",
                                      fontWeight: "bold",
                                    }}
                                    className="text-start"
                                  >
                                    Control Accounts Total :-
                                  </td>

                                  <td
                                    style={{
                                      color: "black",
                                      fontWeight: "bold",
                                      borderTop: "2px solid black",
                                      borderBottom: "2px solid black",
                                    }}
                                    className="text-center"
                                  >
                                    {Intl.NumberFormat("en-Us").format(
                                      subitem.sub_account.reduce(
                                        (a, c) => a + parseInt(c.credit - c.debit),
                                        0
                                      )
                                    )}
                                  </td>
                                </tr>
                              </>
                            ) : null
                          )}
                        </>
                      ) : null
                    )}
                  <Divider />
                  <tr id="tbl">
                    <th
                      className="text-center text-color-primary"
                      style={{ fontSize: "1.3rem" }}
                    >
                      Total EXPENDITURE
                    </th>
                    <th></th>
                    <th
                      className="text-center text-color-primary"
                      style={{ fontSize: "1.3rem" }}
                    >
                      {Intl.NumberFormat("en-Us").format(deSum)}
                    </th>
                  </tr>
                  {expen &&
                    expen.map((item) =>
                      item.account_chart.length > 0 ? (
                        <>
                          <tr id="tbl">
                            <td
                              style={{ color: "#fd12b3", fontWeight: "bold" }}
                              className="text-start"
                            >
                              {item.account_group_code}
                            </td>
                            <td
                              style={{ color: "#fd12b3", fontWeight: "bold" }}
                              className="text-start"
                            >
                              {item.account_group}
                            </td>
                            <td
                              style={{ color: "#fd12b3", fontWeight: "bold" }}
                              className="text-start"
                            >
                              {/* {item.account_group} */}
                            </td>
                          </tr>
                          {item.account_chart.map((subitem) =>
                            subitem.sub_account.length > 0 ? (
                              <>
                                <tr id="tbl">
                                  <td
                                    style={{
                                      color: "black",
                                      paddingLeft: "30px",
                                      fontWeight: "bold",
                                    }}
                                    className="text-start"
                                  >
                                    {subitem.account_chart_code}
                                  </td>
                                  <td
                                    style={{
                                      color: "black",
                                      paddingLeft: "30px",
                                      fontWeight: "bold",
                                    }}
                                    className="text-start"
                                  >
                                    {subitem.account_chart}
                                  </td>

                                  <td
                                    style={{ color: "black" }}
                                    className="text-center"
                                  >
                                    {/* {subitem.debit} */}
                                  </td>
                                </tr>
                                {subitem.sub_account.length > 0
                                  ? subitem.sub_account.map((last) => (
                                      <>
                                        <tr id="tbl">
                                          <td
                                            style={{
                                              color: "black",
                                              paddingLeft: "60px",
                                            }}
                                            className="text-start"
                                          >
                                            {last.sub_account_code}
                                          </td>
                                          <td
                                            style={{
                                              color: "black",
                                              paddingLeft: "60px",
                                            }}
                                            className="text-start"
                                          >
                                            {last.sub_account}
                                          </td>

                                          <td
                                            style={{ color: "black" }}
                                            className="text-center"
                                          >
                                            {Intl.NumberFormat("en-Us").format(
                                              last.debit -last.credit
                                            )}
                                          </td>
                                        </tr>
                                      </>
                                    ))
                                  : null}
                                <tr id="tbl">
                                  <td
                                    style={{
                                      color: "black",
                                      paddingLeft: "30px",
                                    }}
                                    className="text-start"
                                  ></td>
                                  <td
                                    style={{
                                      color: "black",
                                      paddingLeft: "200px",
                                      fontWeight: "bold",
                                    }}
                                    className="text-start"
                                  >
                                    Control Accounts Total :-
                                  </td>

                                  <td
                                    style={{
                                      color: "black",
                                      fontWeight: "bold",
                                      borderTop: "2px solid black",
                                      borderBottom: "2px solid black",
                                    }}
                                    className="text-center"
                                  >
                                    {Intl.NumberFormat("en-Us").format(
                                      subitem.sub_account.reduce(
                                        (a, c) => a + parseInt(c.debit - c.credit),
                                        0
                                      )
                                    )}
                                  </td>
                                </tr>
                              </>
                            ) : null
                          )}
                        </>
                      ) : null
                    )}
                </tbody>
              </Table>
            </div>
          )}
        </div>

        <div
          ref={componentRef}
          id="printSection"
          style={{ visibility: "hidden" }}
          className="tablePrint"
        >
          <div id="tableboot">
            <div className="d-flex">
              <div className="">
                <img
                  style={{ height: 100, width: 110, paddingLeft: "20px" }}
                  src={icon}
                  alt="logo"
                />
              </div>
              <div className="mx-5" style={{ paddingTop: "10px" }}>
                <h1>{unitName}</h1>
                <h3>
                  Income & Expenditure Statement for the Period of {startDate}{" "}
                  to {endDate}
                </h3>
              </div>
            </div>
            <Table responsive>
              <thead>
                <tr id="tbl">
                  <th className="text-start" style={{ fontSize: "20px" }}>
                    A/C Code
                  </th>
                  <th className="text-start" style={{ fontSize: "20px" }}>
                    Account Name
                  </th>
                  <th className="text-center" style={{ fontSize: "20px" }}>
                    Amount
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr id="tbl">
                  <th
                    className="text-center"
                    style={{
                      fontSize: "19px",
                      color: `${config.txtColor}`,
                      padding: "1px",
                      whiteSpace: "normal",
                    }}
                  >
                    Total Revenue
                  </th>
                  <th></th>
                  <th
                    className="text-center"
                    style={{
                      fontSize: "19px",
                      color: `${config.txtColor}`,
                      padding: "1px",
                      whiteSpace: "normal",
                    }}
                  >
                    {Intl.NumberFormat("en-Us").format(revSum)}
                  </th>
                </tr>
                {revenue &&
                  revenue.map((item) =>
                    item.account_chart.length > 0 ? (
                      <>
                        <tr id="tbl">
                          <td
                            style={{
                              color: "#fd12b3",
                              fontWeight: "bold",
                              fontSize: "18px",
                              padding: "1px",
                              whiteSpace: "normal",
                            }}
                            className="text-start"
                          >
                            {item.account_group_code}
                          </td>
                          <td
                            style={{
                              color: "#fd12b3",
                              fontWeight: "bold",
                              fontSize: "18px",
                              padding: "1px",
                              whiteSpace: "normal",
                            }}
                            className="text-start"
                          >
                            {item.account_group}
                          </td>
                          <td
                            style={{
                              color: "#fd12b3",
                              fontWeight: "bold",
                              fontSize: "18px",
                              padding: "1px",
                              whiteSpace: "normal",
                            }}
                            className="text-start"
                          >
                            {/* {item.account_group} */}
                          </td>
                        </tr>
                        {item.account_chart.map((subitem) =>
                          subitem.sub_account.length > 0 ? (
                            <>
                              <tr id="tbl">
                                <td
                                  style={{
                                    color: "black",
                                    paddingLeft: "30px",
                                    fontWeight: "bold",
                                    fontSize: "17px",
                                    padding: "1px",
                                    whiteSpace: "normal",
                                  }}
                                  className="text-start"
                                >
                                  {subitem.account_chart_code}
                                </td>
                                <td
                                  style={{
                                    color: "black",
                                    paddingLeft: "30px",
                                    fontWeight: "bold",
                                    fontSize: "17px",
                                    padding: "1px",
                                    whiteSpace: "normal",
                                  }}
                                  className="text-start"
                                >
                                  {subitem.account_chart}
                                </td>

                                <td
                                  style={{
                                    color: "black",
                                    padding: "1px",
                                    whiteSpace: "normal",
                                  }}
                                  className="text-center"
                                >
                                  {/* {subitem.credit} */}
                                </td>
                              </tr>
                              {subitem.sub_account.length > 0
                                ? subitem.sub_account.map((last) => (
                                    <>
                                      <tr id="tbl">
                                        <td
                                          style={{
                                            color: "black",
                                            paddingLeft: "60px",
                                            fontSize: "16px",
                                            padding: "1px",
                                            whiteSpace: "normal",
                                          }}
                                          className="text-start"
                                        >
                                          {last.sub_account_code}
                                        </td>
                                        <td
                                          style={{
                                            color: "black",
                                            paddingLeft: "60px",
                                            fontSize: "16px",
                                            padding: "1px",
                                            whiteSpace: "normal",
                                          }}
                                          className="text-start"
                                        >
                                          {last.sub_account}
                                        </td>

                                        <td
                                          style={{
                                            color: "black",
                                            fontSize: "16px",
                                            padding: "1px",
                                            whiteSpace: "normal",
                                          }}
                                          className="text-center"
                                        >
                                          {Intl.NumberFormat("en-Us").format(
                                            last.credit - last.debit
                                          )}
                                        </td>
                                      </tr>
                                    </>
                                  ))
                                : null}
                              <tr id="tbl">
                                <td
                                  style={{
                                    color: "black",
                                    paddingLeft: "30px",
                                    padding: "1px",
                                    whiteSpace: "normal",
                                  }}
                                  className="text-start"
                                ></td>
                                <td
                                  style={{
                                    color: "black",
                                    paddingLeft: "200px",
                                    fontWeight: "bold",
                                    fontSize: "17px",
                                    padding: "1px",
                                    whiteSpace: "normal",
                                  }}
                                  className="text-start"
                                >
                                  Control Accounts Total :-
                                </td>

                                <td
                                  style={{
                                    color: "black",
                                    fontWeight: "bold",
                                    borderTop: "2px solid black",
                                    borderBottom: "2px solid black",
                                    padding: "1px",
                                    whiteSpace: "normal",
                                    fontSize: "17px",
                                  }}
                                  className="text-center"
                                >
                                  {Intl.NumberFormat("en-Us").format(
                                    subitem.sub_account.reduce(
                                      (a, c) => a + parseInt(c.credit - c.debit),
                                      0
                                    )
                                  )}
                                </td>
                              </tr>
                            </>
                          ) : null
                        )}
                      </>
                    ) : null
                  )}
                <tr id="tbl">
                  <th
                    className="text-center"
                    style={{
                      fontSize: "18px",
                      color: `${config.txtColor}`,
                      padding: "1px",
                      whiteSpace: "normal",
                    }}
                  >
                    Total EXPENDITURE
                  </th>
                  <th></th>
                  <th
                    className="text-center"
                    style={{
                      fontSize: "18px",
                      color: `${config.txtColor}`,
                      padding: "1px",
                      whiteSpace: "normal",
                    }}
                  >
                    {Intl.NumberFormat("en-Us").format(deSum)}
                  </th>
                </tr>
                {expen &&
                  expen.map((item) =>
                    item.account_chart.length > 0 ? (
                      <>
                        <tr id="tbl">
                          <td
                            style={{
                              color: "#fd12b3",
                              fontWeight: "bold",
                              fontSize: "17px",
                              padding: "1px",
                              whiteSpace: "normal",
                            }}
                            className="text-start"
                          >
                            {item.account_group_code}
                          </td>
                          <td
                            style={{
                              color: "#fd12b3",
                              fontWeight: "bold",
                              fontSize: "17px",
                              padding: "1px",
                              whiteSpace: "normal",
                            }}
                            className="text-start"
                          >
                            {item.account_group}
                          </td>
                          <td
                            style={{
                              color: "#fd12b3",
                              fontWeight: "bold",
                              fontSize: "17px",
                              padding: "1px",
                              whiteSpace: "normal",
                            }}
                            className="text-start"
                          >
                            {/* {item.account_group} */}
                          </td>
                        </tr>
                        {item.account_chart.map((subitem) =>
                          subitem.sub_account.length > 0 ? (
                            <>
                              <tr id="tbl">
                                <td
                                  style={{
                                    color: "black",
                                    paddingLeft: "30px",
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                    padding: "1px",
                                    whiteSpace: "normal",
                                  }}
                                  className="text-start"
                                >
                                  {subitem.account_chart_code}
                                </td>
                                <td
                                  style={{
                                    color: "black",
                                    paddingLeft: "30px",
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                    padding: "1px",
                                    whiteSpace: "normal",
                                  }}
                                  className="text-start"
                                >
                                  {subitem.account_chart}
                                </td>

                                <td
                                  style={{
                                    color: "black",
                                    fontSize: "16px",
                                    padding: "1px",
                                    whiteSpace: "normal",
                                  }}
                                  className="text-center"
                                >
                                  {/* {subitem.debit} */}
                                </td>
                              </tr>
                              {subitem.sub_account.length > 0
                                ? subitem.sub_account.map((last) => (
                                    <>
                                      <tr id="tbl">
                                        <td
                                          style={{
                                            color: "black",
                                            paddingLeft: "60px",
                                            fontSize: "16px",
                                            padding: "1px",
                                            whiteSpace: "normal",
                                          }}
                                          className="text-start"
                                        >
                                          {last.sub_account_code}
                                        </td>
                                        <td
                                          style={{
                                            color: "black",
                                            paddingLeft: "60px",
                                            fontSize: "16px",
                                            padding: "1px",
                                            whiteSpace: "normal",
                                          }}
                                          className="text-start"
                                        >
                                          {last.sub_account}
                                        </td>

                                        <td
                                          style={{
                                            color: "black",
                                            fontSize: "16px",
                                            padding: "1px",
                                            whiteSpace: "normal",
                                          }}
                                          className="text-center"
                                        >
                                          {Intl.NumberFormat("en-Us").format(
                                            last.debit - last.credit
                                          )}
                                        </td>
                                      </tr>
                                    </>
                                  ))
                                : null}
                              <tr id="tbl">
                                <td
                                  style={{
                                    color: "black",
                                    paddingLeft: "30px",
                                    fontSize: "16px",
                                    padding: "1px",
                                    whiteSpace: "normal",
                                  }}
                                  className="text-start"
                                ></td>
                                <td
                                  style={{
                                    color: "black",
                                    paddingLeft: "200px",
                                    fontWeight: "bold",
                                    fontSize: "17px",
                                    padding: "1px",
                                    whiteSpace: "normal",
                                  }}
                                  className="text-start"
                                >
                                  Control Accounts Total :-
                                </td>

                                <td
                                  style={{
                                    color: "black",
                                    fontWeight: "bold",
                                    borderTop: "2px solid black",
                                    borderBottom: "2px solid black",
                                    fontSize: "17px",
                                    padding: "1px",
                                    whiteSpace: "normal",
                                  }}
                                  className="text-center"
                                >
                                  {Intl.NumberFormat("en-Us").format(
                                    subitem.sub_account.reduce(
                                      (a, c) => a + parseInt(c.debit - c.credit),
                                      0
                                    )
                                  )}
                                </td>
                              </tr>
                            </>
                          ) : null
                        )}
                      </>
                    ) : null
                  )}
              </tbody>
            </Table>
            <div className="row mt-3">
              {profit > 0 ? (
                <div className="col-md-12 text-center  mt-3">
                  <h2
                    style={{ fontStyle: "italic", color: `${config.txtColor}` }}
                  >
                    Profit Credited Rs:{" "}
                    {Intl.NumberFormat("en-Us").format(profit)}
                  </h2>
                  <div className="linnerContaioner">
                    <div className="linner"></div>
                  </div>
                </div>
              ) : null}

              {loss > 0 ? (
                <div className="col-md-12 text-center mt-3">
                  <h2 className="text-danger">
                    Loss Rs: {Intl.NumberFormat("en-Us").format(loss)}
                  </h2>
                  <div className="linnerContaioner">
                    <div className="linner"></div>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
        <div className="row">
          {profit > 0 ? (
            <div className="col-md-12 text-center mt-3">
              <h2 style={{ fontStyle: "italic", color: `${config.txtColor}` }}>
                Profit Credited Rs: {Intl.NumberFormat("en-Us").format(profit)}
              </h2>
              <div className="linnerContaioner">
                <div className="linner"></div>
              </div>
            </div>
          ) : null}

          {loss > 0 ? (
            <div className="col-md-12 text-center mt-3">
              <h2 className="text-danger">
                Loss Rs: {Intl.NumberFormat("en-Us").format(loss)}
              </h2>
              <div className="linnerContaioner">
                <div className="linner"></div>
              </div>
            </div>
          ) : null}
        </div>
      </Paper>
    </>
  );
};

export default IncomeExpenditure;
